<template>
  <div>
    <div
      class="grid lg:grid-cols-12 md:grid-cols-6 grid-cols-1 gap-2 w-full items-center py-4 my-0"
    >
      <div class="lg:col-span-4 md:col-span-4 col-span-12 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">Pessoa/Grupo com Acesso:</span>
        <p class="md:text-left">Ezequiel</p>
      </div>

      <div class="lg:col-span-4 md:col-span-4 col-span-12 flex flex-row">
        <span class="text-left font-bold md:hidden mr-2">E-mail:</span>
        <p class="md:text-left truncate">ezequiel.campos@boasnovasgestao.com.br</p>
      </div>

      <div class="lg:col-span-4 md:col-span-4 col-span-12 flex flex-row items-center">
        <span class="text-left font-bold md:hidden mr-2">Nível de acesso:</span>

        <v-select
          v-model="subject.resource_relation"
          :items="permissionsForSelect"
          item-title="label"
          item-value="value"
          color="primary20"
          density="compact"
          variant="plain"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" :disabled="item.raw.disabled"></v-list-item>
          </template>
        </v-select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface PermissionOption {
  label: string
  value: string
  disabled?: boolean
}

const permissionsForSelect = ref<PermissionOption[]>([
  { label: 'Proprietário', value: 'owner' },
  { label: 'Visualizar informações', value: 'info' },
  { label: 'Editar informações', value: 'edit' },
  { label: 'Administrador', value: 'admin' }
])

const subject = ref({
  name: 'Ezequiel',
  email: 'ezequiel.campos@boasnovasgestao.com.br',
  resource_relation: 'info'
})
</script>
